import { Injectable } from '@angular/core';
import { VIDEOS_AND_EVENTS_CATEGORIES } from 'src/app/modules/shared/enums/videos-and-events.enum';
import { IVideo } from '../../interfaces/videosByCategory';

export interface IDateLabel {
  type: 'soon' | 'live' | 'liveEnded' | 'published' | 'empty';
  label: string;
}

@Injectable({
  providedIn: 'root'
})
export class VideoDateLabelFormatterService {
  formatDateLabel(video: IVideo): IDateLabel {
    const { data: dateObj, categoryId, statusTransmissaoValue } = video;

    if (!dateObj) return { type: 'empty', label: '' };

    const isLiveCategory = categoryId === '275';

    const day = dateObj.dayOfMonth;
    const month = dateObj.monthName.slice(0, 3).toUpperCase();
    const year = dateObj.year;

    if (!isLiveCategory) {
      return {
        type: 'published',
        label: `PUBLICADO EM ${day} ${month} ${year}`
      };
    }

    if (statusTransmissaoValue === 'ao_vivo') {
      return { type: 'live', label: 'AO VIVO' };
    }

    if (statusTransmissaoValue === 'agendada') {
      const transmissionDate = video.dateTimeTransmissao
        ? new Date(video.dateTimeTransmissao)
        : new Date(dateObj.rawValue);

      if (transmissionDate > new Date()) {
        const hours = transmissionDate.getHours().toString().padStart(2, '0');
        const minutes = transmissionDate
          .getMinutes()
          .toString()
          .padStart(2, '0');

        const tDay = transmissionDate.getDate();
        const tMonth = transmissionDate
          .toLocaleString('pt-BR', { month: 'short' })
          .slice(0, 3)
          .toUpperCase();
        const tYear = transmissionDate.getFullYear();

        return {
          type: 'soon',
          label: `INICIA EM ${tDay} ${tMonth} ${tYear} às ${hours}:${minutes}h`
        };
      }
    }

    return {
      type: 'liveEnded',
      label: `TRANSMITIDO EM ${day} ${month} ${year}`
    };
  }
}
